import { render, staticRenderFns } from "./SolutionPage3.vue?vue&type=template&id=7a445a68&scoped=true"
import script from "./SolutionPage3.vue?vue&type=script&lang=js"
export * from "./SolutionPage3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a445a68",
  null
  
)

export default component.exports